import React from 'react';
import { Platform } from 'react-native';
import { WebView } from 'react-native-webview';

function isDirectHttpVideoUri(uri) {
  if (!uri || typeof uri !== 'string') return false;
  const path = uri.split('?')[0].toLowerCase();
  return /\.(mp4|webm|mov|m4v|mpeg|mpg)(\?|$)/i.test(path);
}

function escapeHtmlAttr(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** YouTube/embed iframes, direct MP4/WebM in HTML5 video (web + native WebView). */
export default function ModalVideoEmbed({ uri, title, webViewStyle }) {
  if (!uri) return null;

  const asVideo = isDirectHttpVideoUri(uri);

  if (asVideo && Platform.OS === 'web') {
    return React.createElement('video', {
      src: uri,
      title: title || 'Video',
      controls: true,
      playsInline: true,
      style: {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        backgroundColor: '#000',
      },
    });
  }

  if (asVideo && Platform.OS !== 'web') {
    const safeSrc = escapeHtmlAttr(uri);
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1"><style>html,body{margin:0;padding:0;width:100%;height:100%;background:#000}video{width:100%;height:100%;object-fit:contain}</style></head><body><video controls playsinline webkit-playsinline src="${safeSrc}"></video></body></html>`;
    return (
      <WebView
        source={{ html }}
        style={webViewStyle}
        allowsFullscreenVideo
        allowsInlineMediaPlayback
        javaScriptEnabled
        domStorageEnabled
        mediaPlaybackRequiresUserAction={false}
        originWhitelist={['*']}
      />
    );
  }

  if (Platform.OS === 'web') {
    return React.createElement('iframe', {
      src: uri,
      title: title || 'Video',
      allow:
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      allowFullScreen: true,
      style: {
        display: 'block',
        width: '100%',
        height: '100%',
        border: 'none',
        backgroundColor: '#000',
      },
    });
  }
  return (
    <WebView
      source={{ uri }}
      style={webViewStyle}
      allowsFullscreenVideo
      allowsInlineMediaPlayback
      javaScriptEnabled
      domStorageEnabled
      mediaPlaybackRequiresUserAction={false}
    />
  );
}
